import { Flex } from "@chakra-ui/react";
import { useSlideInMenu } from "../hooks/useSlideInMenu";
import { SlideInHeader } from "../components/SlideInHeader";
import { SLIDE_IN_MENUS } from "../../../screens/root/constants";
import { UserProfileContent } from "./UserProfileContent";

interface UserProfileProps {
  onCloseMenu?: () => void;
}

export function UserProfile({ onCloseMenu }: UserProfileProps) {
  const { username, navigationContext, goBack } = useSlideInMenu();

  return (
    <Flex flexDirection="column" height="100%">
      <SlideInHeader
        openMenu={SLIDE_IN_MENUS.userProfile}
        onCloseMenu={onCloseMenu}
        handleBack={goBack}
      />
      <UserProfileContent
        username={username ?? ""}
        navigationContext={navigationContext}
      />
    </Flex>
  );
}
